const AUTH_LOGOUT_EVENT_STORAGE_KEY = 'vadAuthLogoutEvent'

const createLogoutEventId = () =>
  globalThis.crypto?.randomUUID?.() ||
  `${Date.now()}-${Math.random().toString(36).slice(2)}`

export const notifyAuthLogout = () => {
  try {
    globalThis.localStorage?.setItem(
      AUTH_LOGOUT_EVENT_STORAGE_KEY,
      createLogoutEventId()
    )
  } catch (error) {
    console.warn('No se pudo notificar el cierre de sesión:', error)
  }
}

export const subscribeToAuthLogout = onLogout => {
  const handleStorage = event => {
    if (event.key !== AUTH_LOGOUT_EVENT_STORAGE_KEY || !event.newValue) return

    onLogout(event.newValue)
  }

  globalThis.addEventListener?.('storage', handleStorage)

  return () => {
    globalThis.removeEventListener?.('storage', handleStorage)
  }
}

export const isSessionActive = state =>
  state?.login?.user?.CustomerInfo?.LoginCode === 200
